import React from 'react'
import Modal from 'react-modal'
import styles from './modalDialog.scss'
import stylesParent from './emailSetup.scss'
import cs from 'classnames'
import underscore from 'underscore'
import nesProp from 'nested-property'
import {connect} from 'react-redux'
import i18n from 'lib/i18n'
import {isAnEmail} from 'lib/validator'
import jsonBeautify from 'json-beautify'

const _ = i18n('office')

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        wordwrap: "break-word"
	},
}

export default class TestEmailDialog extends React.Component {
	static propTypes = {
        modalIsOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string,
        finishLabel: React.PropTypes.string,
        options: React.PropTypes.object,
        onSendResultMessage: React.PropTypes.object,
        onFinish: React.PropTypes.func,
    }
    constructor(props) {
        super(props)
		this.state = {step: 0, toAddress: '', toAddressTouched: false, toAddressError: ''}
    }

    validateForm(forceTouche = null) {
        const {toAddress} = this.state

        if (forceTouche === false) {
            this.setState({toAddressTouched: false})
        }

        if (forceTouche === true) {
            this.setState({toAddressTouched: true})
        }

        if (!isAnEmail(toAddress)) {
            this.setState({toAddressError: _('wrongEmailFormat')})
            return false
        }

        this.setState({toAddressError: ''})

        return true
    }

	render() {
        const {modalIsOpen, onCancel, onConfirmation, onFinish, cancelLabel, confirmationLabel, finishLabel,
            options, onSendResultMessage} = this.props
        const {toAddress, toAddressTouched, toAddressError, step} = this.state

		return (
            <div>
				<Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>
                            {_("testTheEmailSettingsModalTitle")}
                        </div>

                        {step == 0 &&
                        <div className={styles.contentWrapper}>
                            <div className={cs(stylesParent.formContent, styles.content)}>
                            <div className={stylesParent.formInputContainer}>
                                <label className={cs(stylesParent.formLabel, stylesParent.sizeS)}>
                                    {_("testTheEmailSettingsModalMessage")}
                                </label>
                            </div>

                            <div className={stylesParent.formInputContainer}>
                                <label className={cs(stylesParent.formLabel, stylesParent.sizeS)}>{_('toAddress')}: </label>
                                <div className={stylesParent.formInputWithError}>
                                    <input
                                        className={cs(stylesParent.formInput, stylesParent.formInputText, stylesParent.sizeL)}
                                        type="text"
                                        value={toAddress}
                                        onChange={(e) => {
                                            return this.setState({toAddress: e.target.value}, () => {
                                                this.validateForm()
                                            })
                                        }}
                                        onBlur={(e) => {
                                            return this.setState({toAddress: e.target.value}, () => {
                                                this.validateForm(true)
                                            })
                                        }}
                                        ref="toAddress"
                                        name="toAddress"
                                    />
                                    <div className={stylesParent.errorMessageContainer}>
                                        <div className={stylesParent.errorMessage}>
                                            {toAddressTouched && toAddressError}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            </div>
                            <div className={styles.buttons}>
                                <div
                                    onClick={() => {
                                        // reset modal values
                                        this.setState({
                                            toAddress: '', toAddressTouched: false, toAddressError: '', step: 0
                                        })

                                        // close modal
                                        return onCancel()
                                    }
                                    }
                                    className={(styles.cancel)}
                                >
                                    {cancelLabel}
                                </div>
                                <div
                                    onClick={() => {
                                        // validate modal, an let it go when success
                                        if (this.validateForm(true)) {
                                            return onConfirmation(this.state.toAddress)
                                            .then(() => {
                                                // move forward modal to step 2
                                                this.setState({step: 1})
                                            })
                                            .catch(() => {
                                                // move forward modal to step 2
                                                this.setState({step: 1})
                                            })
                                        }

                                        // on error let it open
                                        return false
                                    }}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {confirmationLabel}
                                </div>
                            </div>
                        </div>}
                        {step == 1 &&
                            <div className={styles.contentWrapper}>
                                <div className={styles.content}>
                                    {_("testTheEmailSettingsModalMessageFinish")}
                                    <br/>
                                    {_('resultOfTestEmailConfigs')}
                                    <br/>
                                    {onSendResultMessage === true ?
                                        _('emailSentSuccessfully')
                                    :
                                        <div className={styles.scrollContent}>
                                            <pre>
                                                {jsonBeautify(onSendResultMessage, null, 2, 80)}
                                            </pre>
                                        </div>
                                    }


                                </div>
                                <div className={styles.buttons}>
                                    <div
                                        onClick={() => {

                                            // reset modal functionality
                                            this.setState({
                                                toAddress: '', toAddressTouched: false, toAddressError: '', step: 0
                                            })

                                            // exit modal permanently and cal callback of parent
                                            return onFinish()
                                        }}
                                        className={cs(styles.next, styles.enabled)}
                                    >
                                        {finishLabel}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/testEmailDialog.jsx